module.exports = __webpack_public_path__ + "img/cert_08.850f7671.jpg";